import { ROLES } from '@/constants/roles';
import { useAuthStore } from '@/features/auth/store/auth.store';

/**
 * Whether the signed-in member of our staff may change a customer's record.
 *
 * The console is open to `PLATFORM_SUPPORT` for reading, but every write on the
 * institutes and feature tracker endpoints carries `authorize('SUPER_ADMIN')`.
 * Screens ask this one question rather than comparing roles themselves, so a
 * button support would only see refused is never offered in the first place,
 * and a change to who may write is made here once. The server stays the
 * authority; hiding the button is courtesy, not security.
 */
export function useIsSuperAdmin(): boolean {
  return useAuthStore((state) => state.user?.role) === ROLES.SUPER_ADMIN;
}
